// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SZEVkcHI67JCwxFOihy1 {
    width: 100%;
    max-width: 72rem;
    margin: 0 auto;
    min-width: 0;
}
.sLGHaQW7enSG4j5JlDmK {
    padding: 1.6rem;
    border: 0.2rem solid transparent;
    border-radius: 1.2rem;
    min-width: 0;
    background: var(--mark-surface);
    overflow-wrap: anywhere;
}
.sLGHaQW7enSG4j5JlDmK:hover,
.sLGHaQW7enSG4j5JlDmK:focus-within {
    border-color: var(--mark-border);
}
.IpssLmA2WRbk25p_4U2Q,
.IpssLmA2WRbk25p_4U2Q:hover,
.IpssLmA2WRbk25p_4U2Q:focus-within {
    border-color: var(--mark-primary);
}
.rKWy3iT2yvOite3W3MaM,
.rKWy3iT2yvOite3W3MaM:hover,
.rKWy3iT2yvOite3W3MaM:focus-within {
    border-color: var(--mark-danger);
}
.aFVPgmUL0YQlaiyPyHYQ {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 1.2rem;
    margin-bottom: 1.6rem;
}
.B9U0llLf4imPdkmN26P9 {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
    min-width: 0;
}
.UUNWIbb_zGnLdGNNkWG5 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 1.2rem;
}
.UcZExJKcF83ThPQNWOMG {
    padding-top: 1.6rem;
}
.bhmq5owle_FLxjBHhHjE {
    display: contents;
}
.Cs7iO8diKTvsGO9ydP5U > summary {
    cursor: pointer;
    padding: 1.2rem;
    color: var(--mark-text);
    font-size: 1.4rem;
    line-height: 2.4rem;
    min-height: 4.4rem;
}
.Cs7iO8diKTvsGO9ydP5U[open] > summary {
    margin-bottom: 0.8rem;
}
.i_wYF7sR7Klcdh4r2kSf {
    display: flex;
    align-items: center;
    gap: 1.2rem;
    padding: 0.4rem 0;
}
.i_wYF7sR7Klcdh4r2kSf::before,
.i_wYF7sR7Klcdh4r2kSf::after {
    content: '';
    height: 0.1rem;
    background: var(--mark-border);
    flex: 1;
}
.i_wYF7sR7Klcdh4r2kSf button,
.i_wYF7sR7Klcdh4r2kSf::before,
.i_wYF7sR7Klcdh4r2kSf::after {
    opacity: 0;
    transition: opacity 120ms ease;
}
.i_wYF7sR7Klcdh4r2kSf:hover button,
.i_wYF7sR7Klcdh4r2kSf:focus-within button,
.i_wYF7sR7Klcdh4r2kSf:last-child button,
.i_wYF7sR7Klcdh4r2kSf:hover::before,
.i_wYF7sR7Klcdh4r2kSf:hover::after,
.i_wYF7sR7Klcdh4r2kSf:focus-within::before,
.i_wYF7sR7Klcdh4r2kSf:focus-within::after,
.i_wYF7sR7Klcdh4r2kSf:last-child::before,
.i_wYF7sR7Klcdh4r2kSf:last-child::after {
    opacity: 1;
}
@media (hover: none) {
    .i_wYF7sR7Klcdh4r2kSf button,
    .i_wYF7sR7Klcdh4r2kSf::before,
    .i_wYF7sR7Klcdh4r2kSf::after {
        opacity: 1;
    }
}
@media (prefers-reduced-motion: reduce) {
    .i_wYF7sR7Klcdh4r2kSf button,
    .i_wYF7sR7Klcdh4r2kSf::before,
    .i_wYF7sR7Klcdh4r2kSf::after {
        transition: none;
    }
}
.nas3OEcQLIhuOYsBBq7Z {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 3.2rem 1.6rem;
    gap: 1.6rem;
}
.hKu6NTBgpWexyCJrd4YG {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1.2rem;
    background: var(--mark-selected);
    padding: 1.6rem;
    border-radius: 1.2rem;
    margin-bottom: 1.6rem;
}
.guNpGSpJUKusVUVu6ILD {
    min-width: 0;
    overflow-wrap: anywhere;
}
.guNpGSpJUKusVUVu6ILD img {
    max-width: 100%;
}
.IqoyZhgjvMTJefldZ42l {
    padding: 1.2rem 0 1.2rem 1.6rem;
    border-left: 0.2rem solid var(--mark-border);
    min-width: 0;
}
.Z7UvFci1QcmbhTQyS_Gc {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1.6rem;
}
.iq3jo0JJhJrjPd0Ofijp {
    width: 100%;
    min-width: 0;
    white-space: normal;
}
.qOOhfczj5aRY51tYl0no {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.8rem;
    text-align: left;
    width: 100%;
    min-width: 0;
    padding: 0.8rem;
}
.ZnAHxZxZmjBHXIsqTSfW {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 0.6rem;
    width: 100%;
    height: 6.4rem;
    padding: 1.2rem;
    box-sizing: border-box;
    background: var(--mark-surface);
    border: 0.1rem solid var(--mark-border);
    border-radius: 0.8rem;
    color: var(--mark-text);
}
.U2Ewp9RQ8QWytfGKMUC2 {
    display: block;
    height: 0.4rem;
    width: 85%;
    border-radius: 0.2rem;
    background: var(--mark-border);
}
.nKxgH_rrfLlVFrn5jKdV {
    background: var(--mark-selected);
    border: 0.2rem solid var(--mark-primary);
    color: var(--mark-text);
    padding: 0.4rem 1.6rem;
    border-radius: 0.6rem;
}
.BqYXSGlID102heUCAsJb {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 0.8rem;
}
/* The element qualifier overrides the HTML editor's .fields regardless of load order. */
fieldset.ScQ5oH8RhMQs_lsgkLge {
    align-items: start;
    grid-template-rows: repeat(3, auto);
}
fieldset.ScQ5oH8RhMQs_lsgkLge > div {
    display: grid;
    grid-row: span 3;
    grid-template-rows: subgrid;
}
.AitLj4YljEI1vcuE_VMG {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 0.8rem;
}
.AitLj4YljEI1vcuE_VMG label {
    min-width: 0;
    margin: 0;
}
.AitLj4YljEI1vcuE_VMG button {
    flex-shrink: 0;
    min-width: 0;
    max-width: 100%;
    white-space: normal;
    overflow-wrap: anywhere;
}
.kEWODcRhC3oyxObX_BJt {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    min-width: 0;
}
.BKQB0UJFJCP0O1wm41Wh textarea {
    min-height: 14.4rem;
    resize: vertical;
}
.EAywFAu46f8XR3upMT0n {
    color: var(--mark-danger);
}
.HxIjp5Y403igqH8zCvGd {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
}
.tBB8pOfItZN3zFgMErdV {
    width: 100%;
    text-align: left;
    white-space: normal;
    min-height: 4.4rem;
}
.JDJV0Jo3hZFpi5VxzaYG {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1.2rem;
}
.SZEVkcHI67JCwxFOihy1 button,
.UUNWIbb_zGnLdGNNkWG5 button,
.i_wYF7sR7Klcdh4r2kSf button,
.iq3jo0JJhJrjPd0Ofijp {
    min-height: 4.4rem;
}
@media (max-width: 600px) {
    .sLGHaQW7enSG4j5JlDmK {
        padding: 1.2rem;
    }
    .Z7UvFci1QcmbhTQyS_Gc {
        grid-template-columns: minmax(0, 1fr);
    }
    .IqoyZhgjvMTJefldZ42l {
        padding-left: 0.8rem;
    }
}
`, "",{"version":3,"sources":["webpack://./pages/Mark/components/BlockEditor/canvas.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,YAAY;AAChB;AACA;IACI,eAAe;IACf,gCAAgC;IAChC,qBAAqB;IACrB,YAAY;IACZ,+BAA+B;IAC/B,uBAAuB;AAC3B;AACA;;IAEI,gCAAgC;AACpC;AACA;;;IAGI,iCAAiC;AACrC;AACA;;;IAGI,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;AACA;;IAEI,WAAW;IACX,cAAc;IACd,8BAA8B;IAC9B,OAAO;AACX;AACA;;;IAGI,UAAU;IACV,8BAA8B;AAClC;AACA;;;;;;;;;IASI,UAAU;AACd;AACA;IACI;;;QAGI,UAAU;IACd;AACJ;AACA;IACI;;;QAGI,gBAAgB;IACpB;AACJ;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,WAAW;IACX,gCAAgC;IAChC,eAAe;IACf,qBAAqB;IACrB,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,uBAAuB;AAC3B;AACA;IACI,eAAe;AACnB;AACA;IACI,+BAA+B;IAC/B,4CAA4C;IAC5C,YAAY;AAChB;AACA;IACI,aAAa;IACb,gDAAgD;IAChD,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,WAAW;IACX,WAAW;IACX,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,+BAA+B;IAC/B,uCAAuC;IACvC,qBAAqB;IACrB,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,cAAc;IACd,UAAU;IACV,qBAAqB;IACrB,8BAA8B;AAClC;AACA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;AACA,wFAAwF;AACxF;IACI,kBAAkB;IAClB,mCAAmC;AACvC;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;AACA;IACI,YAAY;IACZ,SAAS;AACb;AACA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,WAAW;AACf;AACA;;;;IAII,kBAAkB;AACtB;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,qCAAqC;IACzC;IACA;QACI,oBAAoB;IACxB;AACJ","sourcesContent":[".canvas {\n    width: 100%;\n    max-width: 72rem;\n    margin: 0 auto;\n    min-width: 0;\n}\n.section {\n    padding: 1.6rem;\n    border: 0.2rem solid transparent;\n    border-radius: 1.2rem;\n    min-width: 0;\n    background: var(--mark-surface);\n    overflow-wrap: anywhere;\n}\n.section:hover,\n.section:focus-within {\n    border-color: var(--mark-border);\n}\n.selected,\n.selected:hover,\n.selected:focus-within {\n    border-color: var(--mark-primary);\n}\n.invalid,\n.invalid:hover,\n.invalid:focus-within {\n    border-color: var(--mark-danger);\n}\n.sectionHeader {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1.2rem;\n    margin-bottom: 1.6rem;\n}\n.editor {\n    display: flex;\n    flex-direction: column;\n    gap: 1.6rem;\n    min-width: 0;\n}\n.actions {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 1.2rem;\n}\n.editorActions {\n    padding-top: 1.6rem;\n}\n.actionGroup {\n    display: contents;\n}\n.moreActions > summary {\n    cursor: pointer;\n    padding: 1.2rem;\n    color: var(--mark-text);\n    font-size: 1.4rem;\n    line-height: 2.4rem;\n    min-height: 4.4rem;\n}\n.moreActions[open] > summary {\n    margin-bottom: 0.8rem;\n}\n.insert {\n    display: flex;\n    align-items: center;\n    gap: 1.2rem;\n    padding: 0.4rem 0;\n}\n.insert::before,\n.insert::after {\n    content: '';\n    height: 0.1rem;\n    background: var(--mark-border);\n    flex: 1;\n}\n.insert :global(button),\n.insert::before,\n.insert::after {\n    opacity: 0;\n    transition: opacity 120ms ease;\n}\n.insert:hover :global(button),\n.insert:focus-within :global(button),\n.insert:last-child :global(button),\n.insert:hover::before,\n.insert:hover::after,\n.insert:focus-within::before,\n.insert:focus-within::after,\n.insert:last-child::before,\n.insert:last-child::after {\n    opacity: 1;\n}\n@media (hover: none) {\n    .insert :global(button),\n    .insert::before,\n    .insert::after {\n        opacity: 1;\n    }\n}\n@media (prefers-reduced-motion: reduce) {\n    .insert :global(button),\n    .insert::before,\n    .insert::after {\n        transition: none;\n    }\n}\n.empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: 3.2rem 1.6rem;\n    gap: 1.6rem;\n}\n.undo {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 1.2rem;\n    background: var(--mark-selected);\n    padding: 1.6rem;\n    border-radius: 1.2rem;\n    margin-bottom: 1.6rem;\n}\n.preview {\n    min-width: 0;\n    overflow-wrap: anywhere;\n}\n.preview :global(img) {\n    max-width: 100%;\n}\n.nested {\n    padding: 1.2rem 0 1.2rem 1.6rem;\n    border-left: 0.2rem solid var(--mark-border);\n    min-width: 0;\n}\n.pickerGrid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 1.6rem;\n}\n.pickerCard {\n    width: 100%;\n    min-width: 0;\n    white-space: normal;\n}\n.pickerCopy {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.8rem;\n    text-align: left;\n    width: 100%;\n    min-width: 0;\n    padding: 0.8rem;\n}\n.sample {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    gap: 0.6rem;\n    width: 100%;\n    height: 6.4rem;\n    padding: 1.2rem;\n    box-sizing: border-box;\n    background: var(--mark-surface);\n    border: 0.1rem solid var(--mark-border);\n    border-radius: 0.8rem;\n    color: var(--mark-text);\n}\n.sampleLine {\n    display: block;\n    height: 0.4rem;\n    width: 85%;\n    border-radius: 0.2rem;\n    background: var(--mark-border);\n}\n.sampleButton {\n    background: var(--mark-selected);\n    border: 0.2rem solid var(--mark-primary);\n    color: var(--mark-text);\n    padding: 0.4rem 1.6rem;\n    border-radius: 0.6rem;\n}\n.fieldLabel {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.8rem;\n}\n/* The element qualifier overrides the HTML editor's .fields regardless of load order. */\nfieldset.metadataFields {\n    align-items: start;\n    grid-template-rows: repeat(3, auto);\n}\nfieldset.metadataFields > div {\n    display: grid;\n    grid-row: span 3;\n    grid-template-rows: subgrid;\n}\n.metadataFieldHeader {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.8rem;\n}\n.metadataFieldHeader :global(label) {\n    min-width: 0;\n    margin: 0;\n}\n.metadataFieldHeader :global(button) {\n    flex-shrink: 0;\n    min-width: 0;\n    max-width: 100%;\n    white-space: normal;\n    overflow-wrap: anywhere;\n}\n.field {\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n    min-width: 0;\n}\n.message :global(textarea) {\n    min-height: 14.4rem;\n    resize: vertical;\n}\n.error {\n    color: var(--mark-danger);\n}\n.personalizationList {\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n}\n.personalizationChoice {\n    width: 100%;\n    text-align: left;\n    white-space: normal;\n    min-height: 4.4rem;\n}\n.deviceToolbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 1.2rem;\n}\n.canvas :global(button),\n.actions :global(button),\n.insert :global(button),\n.pickerCard {\n    min-height: 4.4rem;\n}\n@media (max-width: 600px) {\n    .section {\n        padding: 1.2rem;\n    }\n    .pickerGrid {\n        grid-template-columns: minmax(0, 1fr);\n    }\n    .nested {\n        padding-left: 0.8rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export var canvas = `SZEVkcHI67JCwxFOihy1`;
export var section = `sLGHaQW7enSG4j5JlDmK`;
export var selected = `IpssLmA2WRbk25p_4U2Q`;
export var invalid = `rKWy3iT2yvOite3W3MaM`;
export var sectionHeader = `aFVPgmUL0YQlaiyPyHYQ`;
export var editor = `B9U0llLf4imPdkmN26P9`;
export var actions = `UUNWIbb_zGnLdGNNkWG5`;
export var editorActions = `UcZExJKcF83ThPQNWOMG`;
export var actionGroup = `bhmq5owle_FLxjBHhHjE`;
export var moreActions = `Cs7iO8diKTvsGO9ydP5U`;
export var insert = `i_wYF7sR7Klcdh4r2kSf`;
export var empty = `nas3OEcQLIhuOYsBBq7Z`;
export var undo = `hKu6NTBgpWexyCJrd4YG`;
export var preview = `guNpGSpJUKusVUVu6ILD`;
export var nested = `IqoyZhgjvMTJefldZ42l`;
export var pickerGrid = `Z7UvFci1QcmbhTQyS_Gc`;
export var pickerCard = `iq3jo0JJhJrjPd0Ofijp`;
export var pickerCopy = `qOOhfczj5aRY51tYl0no`;
export var sample = `ZnAHxZxZmjBHXIsqTSfW`;
export var sampleLine = `U2Ewp9RQ8QWytfGKMUC2`;
export var sampleButton = `nKxgH_rrfLlVFrn5jKdV`;
export var fieldLabel = `BqYXSGlID102heUCAsJb`;
export var metadataFields = `ScQ5oH8RhMQs_lsgkLge`;
export var metadataFieldHeader = `AitLj4YljEI1vcuE_VMG`;
export var field = `kEWODcRhC3oyxObX_BJt`;
export var message = `BKQB0UJFJCP0O1wm41Wh`;
export var error = `EAywFAu46f8XR3upMT0n`;
export var personalizationList = `HxIjp5Y403igqH8zCvGd`;
export var personalizationChoice = `tBB8pOfItZN3zFgMErdV`;
export var deviceToolbar = `JDJV0Jo3hZFpi5VxzaYG`;
export default ___CSS_LOADER_EXPORT___;
